import { render } from "./ParkingDescribe.vue?vue&type=template&id=6144bd9e&scoped=true"
import script from "./ParkingDescribe.vue?vue&type=script&lang=js"
export * from "./ParkingDescribe.vue?vue&type=script&lang=js"

import "./ParkingDescribe.vue?vue&type=style&index=0&id=6144bd9e&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6144bd9e"]])

export default __exports__